<template>
  <app-side-menu
    :min-width="18"
    :fixed-menu="false">
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Vehicle Lookup Setup
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <router-link
            :to="{ name: routeTypes.PricingView.name }"
            active-class="is-active"
            exact>
            <span>
              Pricing
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: routeTypes.SubscriptionView.name }"
            active-class="is-active"
            exact>
            <span>
              Subscription
            </span>
          </router-link>
        </li>
      </ul>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import VehicleLookupRoutes from './route-types'

export default {
  name: 'VehicleLookupSideMenu',
  components: {
    AppSideMenu
  },
  props: {},
  data() {
    return {}
  },
  computed: {routeTypes() {
      return VehicleLookupRoutes
    }
  },
  mounted() {},
  methods: {}
}
</script>
